import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Avatar from "../../assets/icons/img/avatar/avatar.png";
import UserDetailCard from "./UserDetailCard";
import UserServices from "./UserServices";
import UserSettings from "./UserSettings";
import { getCurrentUser, updateUser } from "@/store/user/user.action";
import { connect } from "react-redux";
import { RootState } from "../../store";
import { ConnectedProps } from "react-redux";
import { useFormik } from "formik";
import UserDetailsFTP from "./UserDetailsFTP";
import { ServiceRequest } from "@/store/user/user.action";
import { formatEntityName } from "@/utils/utilFunctions/entityName";

export interface Option {
  label: string;
  value: number | string | string[] | Option[] | number[];
}

export const UserDetails = ({
  businessList,
  productList,
  bunchAllProductList,
  bunchAllBusinessList,
  metaLanguage,
  updateUser,
  ServiceRequest,

  singleCurrentUser,
}: Props) => {
  const { userId } = useParams<{ userId: string }>();
  const [sampleListings, setSampleListings] = useState<any[]>([]);
  const [visibleCount, setVisibleCount] = useState(
    sampleListings.length > 6 ? 4 : sampleListings.length
  );
  const [userFormik, setUserFormik] = useState(false);
  const [filteredProductList, setFilteredProductList] = useState<any[]>([]);
  const [filteredDefaultList, setFilteredDefaultList] = useState<any[]>([]);
  const [requestedPermissions, setRequestedPermissions] = useState<any[]>([]);
  const [requestedPermissionsStatus, setRequestedPermissionsStatus] = useState<
    any[]
  >([]);
  const [userSettings, setUserSettings] = useState({
    notifications: {},
    settings: {},
    default_team: singleCurrentUser?.default_team,
    default_business: singleCurrentUser?.default_business,
  });

  useEffect(() => {
    const updated = singleCurrentUser?.user_req
      ?.filter((req: any) => req.status === 0 || req.status === 7)
      ?.map((req: any) => {
        const per = req.business + "." + req.team + "." + req.service;
        return per;
      });
    const updatedStatus = singleCurrentUser?.user_req
      ?.filter((req: any) => req.status === 0 || req.status === 7)
      ?.map((req: any) => {
        return req.status;
      });

    setRequestedPermissions(updated);
    setRequestedPermissionsStatus(updatedStatus);
  }, [singleCurrentUser?.user_req]);

  useEffect(() => {
    setVisibleCount(sampleListings.length > 6 ? 4 : sampleListings.length);
  }, [sampleListings]);

  const initialValues = {
    email: singleCurrentUser?.email || "",
    emails: singleCurrentUser?.emails || [],
    name: singleCurrentUser?.name || "",
    phone: singleCurrentUser?.phone || "",
    business: singleCurrentUser?.business || "",
    team: singleCurrentUser?.team || "",
    login_security: singleCurrentUser?.login_security || 1,
    login_type: singleCurrentUser?.login_type || 1,
    username: singleCurrentUser?.email
      ? singleCurrentUser.email.split("@")[0]
      : "",
    status: 1,
    permissions: singleCurrentUser?.permissions || [],
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: (values) => {},
  });

  useEffect(() => {
    const transformedPermissions = formik.values.permissions.map(
      (permission, index) => ({
        id: permission,
        title: permission,
        isChecked: true,
        image: Avatar,
      })
    );
    setSampleListings(transformedPermissions);
  }, [formik.values.permissions]);

  const businessIdToNameMapping = businessList?.reduce(
    (acc: any, business: any) => {
      acc[business.id] = business.name;
      return acc;
    },
    {} as Record<string, string>
  );

  const productIdToNameMapping = productList?.reduce(
    (acc: any, product: any) => {
      acc[product.id] = product.name;
      return acc;
    },
    {} as Record<string, string>
  );

  useEffect(() => {
    if (formik.values.business) {
      const filteredProducts = productList?.filter(
        (product: any) => product.business === formik.values.business
      );
      setFilteredProductList(filteredProducts);
    } else {
      setFilteredProductList([]);
    }
  }, [formik.values.business, productList]);

  useEffect(() => {
    if (userSettings.default_business) {
      const filteredProducts = productList?.filter(
        (product: any) => product.business === userSettings.default_business
      );
      setFilteredDefaultList(filteredProducts);
    }
  }, [userSettings.default_business, productList]);

  useEffect(() => {
    if (!userSettings.default_business && singleCurrentUser?.default_business) {
      const filteredProducts = productList?.filter(
        (product: any) =>
          product.business === singleCurrentUser?.default_business
      );
      setFilteredDefaultList(filteredProducts);
    }
  }, [singleCurrentUser?.default_business, productList, userSettings]);

  const formattedBusinessList = businessList?.map((business: any) => ({
    label: formatEntityName(business) || "N/A",
    value: business.id,
  }));

  const formattedDefaultList = filteredDefaultList.map((product: any) => ({
    label: formatEntityName(product) || "N/A",
    value: product.id,
  }));

  const handleDetailsSave = (newPermissions: any) => {
    formik.validateForm();
    if (!formik.isValid) {
      return;
    }
    const formData = {
      id: userId,
      permissions: newPermissions,
    };
    updateUser(formData);
  };

  return (
    <div className="container px-3">
      <form className="d-flex flex-column py-4" onSubmit={formik.handleSubmit}>
        <UserDetailCard
          img={Avatar}
          name={formik.values.name || "N/A"}
          phoneNumber={formik.values.phone || "N/A"}
          details={[
            { label: "Primary Email:", value: formik.values.email || "N/A" },
            {
              label: "Secondary Email :",
              value: formik.values.emails[0] || "N/A",
            },
            {
              label: "Business :",
              value:
                businessIdToNameMapping[formik.values.business] ||
                formik.values.business ||
                "N/A",
            },
            {
              label: "Team :",
              value:
                productIdToNameMapping[formik.values.team] ||
                formik.values.team ||
                "N/A",
            },
          ]}
        />
        <div className="mt-4">
          <UserDetailsFTP
            status={singleCurrentUser?.ftp?.status}
            currentUser={singleCurrentUser}
            updateUser={updateUser}
            email={singleCurrentUser?.email}
            pass={singleCurrentUser?.ftp?.password}
          />
        </div>
        <div className="card my-4">
          {requestedPermissions?.length > 0 && (
            <UserServices
              value={requestedPermissions}
              onChange={(perms) => formik.setFieldValue("permissions", perms)}
              productList={bunchAllProductList}
              businessList={bunchAllBusinessList}
              onRequest={handleDetailsSave}
              currentUser={singleCurrentUser}
              ServiceRequest={ServiceRequest}
              isProfile={true}
              isRequested={true}
              requestedPermissionsStatus={requestedPermissionsStatus}
              showHeader={true}
            />
          )}
          {/* {(requestedPermissions?.length < 4 || !requestedPermissions?.length) && ( */}
          <UserServices
            value={formik.values.permissions}
            onChange={(perms) => formik.setFieldValue("permissions", perms)}
            productList={bunchAllProductList}
            businessList={bunchAllBusinessList}
            onRequest={handleDetailsSave}
            currentUser={singleCurrentUser}
            ServiceRequest={ServiceRequest}
            isProfile={true}
            showHeader={requestedPermissions?.length > 0 ? false : true}
            showPermissionCount={
              requestedPermissions?.length > 0 &&
              requestedPermissions?.length < 4
                ? 4 - requestedPermissions?.length
                : 4
            }
          />
          {/* )} */}
        </div>
        <UserSettings
          productOptions={formattedDefaultList}
          businessOptions={formattedBusinessList}
          metaLanguageOptions={metaLanguage}
          onSettingsChange={(changedVal: any) => {
            setUserFormik(true);
            setUserSettings((prev) => {
              const newNotifications = {
                ...prev.notifications,
                ...(changedVal.notifications || {}),
              };
              const newSettings = {
                ...prev.settings,
                ...(changedVal.settings || {}),
              };
              const newDefaultProduct =
                changedVal.default_team !== undefined
                  ? changedVal.default_team
                  : prev.default_team;
              const newDefaultBusiness =
                changedVal.default_business !== undefined
                  ? changedVal.default_business
                  : prev.default_business;
              const newState = {
                ...prev,
                notifications: newNotifications,
                settings: newSettings,
                default_team: newDefaultProduct,
                default_business: newDefaultBusiness,
              };
              return newState;
            });
          }}
          currentUser={singleCurrentUser}
        />
      </form>
    </div>
  );
};

const mapState = (state: RootState) => ({
  metaLanguage: state.app.metaLanguage,

  singleCurrentUser: state.users.singleCurrentUser,
  businessList: state.constants.bunchBusinessList.list,
  productList: state.constants.bunchProductList.list,
  bunchAllProductList: state.constants.bunchAllProductList.list,
  bunchAllBusinessList: state.constants.bunchAllBusinessList.list,
});
const mapDispatch = {
  getCurrentUser,
  updateUser,
  ServiceRequest,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector>;

export default connector(UserDetails);
